import React, { FC, useState } from 'react';
import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CustomDatePicker from '../../../common/components/CustomDatePicker/CustomDatePicker';

interface IBusinessEditDatesItem {
  label: string;
  date: Date | null | undefined;
  onChange: (date: any) => void;
  editable?: boolean;
}

const BusinessEditDatesItem: FC<IBusinessEditDatesItem> = (props) => {
  const { label, date, onChange, editable } = props;
  const classes = useStyles();
  const [pickerOpened, setPickerOpened] = useState(false);

  const handleEdit = () => {
    setPickerOpened(true);
  };

  const handleClose = () => {
    setPickerOpened(false);
  };

  return (
    <>
      <Grid item xs={12} sm={5} className={classes.left}>
        <Typography className={classes.label}>{label} :</Typography>
      </Grid>
      <Grid item xs={11} sm={6} className={classes.left}>
        <CustomDatePicker
          style={{ margin: 0 }}
          value={date}
          open={pickerOpened}
          onOpen={() => {}}
          onClose={() => handleClose()}
          onChange={(_date) => onChange(_date)}
        />
      </Grid>
      <Grid item xs={1} sm={1} className={classes.right}>
        {editable && <EditIcon className={classes.icon} onClick={handleEdit} />}
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    right: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
    input: {
      flex: 1,
    },
    disabled: {
      color: 'black',
    },
  }),
);

export default BusinessEditDatesItem;
